import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/materialAuth/page',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/materialAuth',
method: 'post',
data: obj
})
}
export function saveAuthObj(obj) {
return request({
url: '/api/admin/materialAuth/saveAuth',
method: 'post',
data: obj
})
}
export function getAll(obj) {
return request({
url: '/api/admin/materialAuth/getAll',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/materialAuth/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/materialAuth/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/materialAuth/' + id,
method: 'put',
data: obj
})
}
